import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Juan P.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Miguel A.',
  location: 'CDMX, México'
}, {
  name: 'Carlos R.',
  location: 'Santiago, Chile'
}, {
  name: 'Diego F.',
  location: 'Lima, Perú'
}, {
  name: 'Roberto S.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Andrés M.',
  location: 'Medellín, Colombia'
}, {
  name: 'Fernando G.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Luis C.',
  location: 'Guadalajara, México'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 12000) + 8000;
      setTimeout(showNextPopup, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[300px] md:max-w-[350px]" data-id="element-228">
      <div className="bg-brand-card rounded-xl shadow-[0_0_30px_rgba(212,161,75,0.4)] border-2 border-brand-accent p-4 flex items-start gap-4 relative overflow-hidden" data-id="element-229">
        <div className="bg-brand-accent/20 p-2.5 rounded-full shrink-0" data-id="element-230">
          <CheckCircle className="w-7 h-7 text-brand-accent" data-id="element-231" />
        </div>
        <div data-id="element-232">
          <p className="text-sm md:text-base text-gray-200 font-medium leading-tight mb-1.5" data-id="element-233">
            <span className="font-black text-white" data-id="element-234">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} acaba de comprar el Mega Pack Herrería
            Moderna 🛠️
          </p>
          <p className="text-xs text-brand-accent font-black uppercase tracking-widest" data-id="element-235">
            Hace unos minutos
          </p>
        </div>
      </div>

      <style data-id="element-236">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}